import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib",
  "use": "icon-ib-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib\">\n    <path d=\"m17.48 12.02-1.647 1.412h-.009l-2.597 2.597-1.005-1.002 1.592-1.595H2.5l-.02-1.412h15zM7.787 4.175 6.192 5.769H17.5v1.344H2.69L4.167 5.77h.012l2.604-2.603 1.004 1.008z\" fill=\"#000018\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol